import {observer} from "mobx-react";
import React, {useEffect, useRef, useState} from "react";
import {Container, Content} from "./styled";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import CheckBoxWithLabel from "@dropDesk/presentation/components/check_box/check_box_with_label";
import {GreenAppColors, SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {ContentCheckbox} from "@dropDesk/presentation/pages/company/ui/form_company/inputs/styled";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import FooterModal from "@dropDesk/presentation/components/footer/footer_modal";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ConstantsStyles} from "@dropDesk/domain/entities/constants/constants_keys";
import ButtonNavigateToBottom from "@dropDesk/presentation/components/buttons/button_navigate_to_bottom";


const ContractInput = observer(
    ({
         contract,
         acceptContract,
         onClickAcceptContract
     }: {
         contract: string | null
         onClickAcceptContract: (value: boolean) => void
         acceptContract: boolean
     }
    ) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const containerContractRef = useRef<HTMLDivElement>(null);
        const [showScrollButton, setShowScrollButton] = useState(false);
        const [visibleModal, setVisibleModal] = useState(false);
        const [contractRead, setContractRead] = useState(false);
        const targetCheckboxId = 'contract-read-checkbox';

        useEffect(() => {
            if (!acceptContract) {
                setContractRead(false);
            }
        }, [acceptContract]);

        useEffect(() => {
            if (visibleModal) {
                const timeoutId = setTimeout(() => {
                    const checkboxElement = document.getElementById(targetCheckboxId);

                    const intersectionObserver = new IntersectionObserver(entries => {
                        if (entries.some(entry => !entry.isIntersecting)) {
                            setShowScrollButton(true);
                        } else {
                            setShowScrollButton(false);
                        }
                    });

                    if (checkboxElement) {
                        intersectionObserver.observe(checkboxElement);
                    }
                }, 300);

                return () => {
                    clearTimeout(timeoutId);
                };
            } else {
                setShowScrollButton(false);
            }
        }, [visibleModal]);

        const moveScrollToBottom = () => {
            if (containerContractRef.current) {
                containerContractRef.current.scrollTo({
                    top: containerContractRef.current.scrollHeight,
                    behavior: 'smooth'
                });
            }
        };

        return (
            <>
                <ContentCheckbox>
                    <CheckBoxWithLabel
                        label={`Estou de acordo com este`}
                        checked={acceptContract}
                        name={'contract'}
                        marginLeft={0}
                        height={10}
                        disabled={false}
                        onChange={(event) => {
                            if (!acceptContract) {
                                setVisibleModal(true);
                            } else {
                                onClickAcceptContract(false);
                            }
                        }}
                        tooltip={'Leia o contrato, ao criar esta conta você está de acordo com este contrato.'}
                    />
                    <a
                        href={`https://www.dropdesk.com.br/contrato-de-servico`}
                        style={{
                            color: colors.textLink,
                            fontWeight: 'bold',
                            fontSize: ConstantsStyles.inputFontSize,
                            textDecoration: 'underline'
                        }}
                        target="_blank">
                        &nbsp;contrato de serviço.
                    </a>
                </ContentCheckbox>
                <ModalMain
                    open={visibleModal}
                    onRequestClose={() => setVisibleModal(false)}
                    width={400}
                    renderComponent={
                        <Container>
                            <HeaderModal
                                disabled={false}
                                letter={"Contrato DropDesk"}
                                nameIcon={ICONS_DROPDESK.close}
                                onClick={() => setVisibleModal(false)}
                            />
                            <Content ref={containerContractRef}>
                                {contract &&
                                    <>
                                        <div dangerouslySetInnerHTML={{__html: contract}}/>
                                        <div id={targetCheckboxId} style={{width: 'fit-content'}}>
                                            <CheckBoxWithLabel
                                                label={`Eu declaro que li e aceito o contrato`}
                                                checked={contractRead}
                                                name={'contractRead'}
                                                marginLeft={0}
                                                disabled={false}
                                                bordercolor={colors.accent}
                                                onChange={(event) => setContractRead(event.target.checked)}
                                            />
                                        </div>
                                    </>
                                }
                                {!contract && <div>Houve um erro ao obter o contrato</div>}


                            </Content>
                            {showScrollButton && (
                                <ButtonNavigateToBottom
                                    onClick={moveScrollToBottom}
                                />
                            )}
                            <FooterModal
                                background={SharedColors.white}
                                backgroundButton={colors.accent}
                                disabled={!contractRead}
                                loading={false}
                                type={"submit"}
                                letter={"Aceito"}
                                onSubmit={() => {
                                    setVisibleModal(false);
                                    onClickAcceptContract(true);
                                }}
                                tooltipButtonOK={!contractRead ? 'Arraste para o fim da tela e aceite o contrato' : ''}
                                onRequestClose={() => setVisibleModal(false)}
                            />
                        </Container>
                    }
                />
            </>
        )
    })
export default ContractInput;
